// Sample patterns for display when backend is not available
// Using valid MongoDB ObjectId format (24 hex characters)
export const samplePatterns = [
  { 
    _id: '507f1f77bcf86cd799439011', 
    title: 'Sukienka z kołnierzykiem', 
    name: 'Sukienka z kołnierzykiem',
    price: '45zł', 
    url: 'https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=300&h=200&fit=crop', 
    photos: [
      { url: 'https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?w=600&h=400&fit=crop' },
      { url: 'https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=600&h=400&fit=crop' },
    ],
    designer: 'Anna K.', 
    description: 'Elegancka sukienka z ozdobnym kołnierzykiem. Idealna na specjalne okazje.',
    descriptionLong: 'Ta piękna sukienka z kołnierzykiem to idealne rozwiązanie na każdą okazję. Wykrój zawiera szczegółowe instrukcje oraz różne rozmiary.',
    categories: ['dresses'], 
    clients: ['female'],
    sizes: ['xs', 's', 'm', 'l', 'xl'],
    fabrics: ['cotton', 'linen'],
    dateUpdated: new Date().toISOString(),
  },
  { 
    _id: '507f1f77bcf86cd799439012', 
    title: 'Wykrój spodni chłopiec', 
    name: 'Wykrój spodni chłopiec',
    price: '25zł', 
    url: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=300&h=200&fit=crop', 
    photos: [
      { url: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=600&h=400&fit=crop' },
    ],
    designer: 'Maria S.', 
    description: 'Wygodne spodnie dla chłopca. Łatwy wykrój dla początkujących.',
    descriptionLong: 'Prosty wykrój spodni dla chłopców. Idealny dla osób rozpoczynających przygodę z szyciem.',
    categories: ['trousers'], 
    clients: ['boy'],
    sizes: ['xs', 's', 'm'],
    fabrics: ['cotton', 'stretch'],
    dateUpdated: new Date().toISOString(),
  },
  { 
    _id: '507f1f77bcf86cd799439013', 
    title: 'Bluzka damska elegancka', 
    name: 'Bluzka damska elegancka',
    price: '35zł', 
    url: 'https://images.unsplash.com/photo-1564257631407-4deb1f99d992?w=300&h=200&fit=crop', 
    photos: [
      { url: 'https://images.unsplash.com/photo-1564257631407-4deb1f99d992?w=600&h=400&fit=crop' },
    ],
    designer: 'Kasia M.', 
    description: 'Elegancka bluzka na każdą okazję.',
    descriptionLong: 'Uniwersalna bluzka damska pasująca zarówno do biura jak i na spotkania towarzyskie.',
    categories: ['blouses'], 
    clients: ['female'],
    sizes: ['s', 'm', 'l', 'xl'],
    fabrics: ['silk', 'rayon'],
    dateUpdated: new Date().toISOString(),
  },
  { 
    _id: '507f1f77bcf86cd799439014', 
    title: 'Spódnica midi', 
    name: 'Spódnica midi',
    price: '30zł', 
    url: 'https://images.unsplash.com/photo-1583496661160-fb5886a0aaaa?w=300&h=200&fit=crop', 
    photos: [
      { url: 'https://images.unsplash.com/photo-1583496661160-fb5886a0aaaa?w=600&h=400&fit=crop' },
    ],
    designer: 'Ola P.', 
    description: 'Modna spódnica midi.',
    descriptionLong: 'Elegancka spódnica o długości midi. Klasyczny fason pasujący do każdej sylwetki.',
    categories: ['skirts'], 
    clients: ['female'],
    sizes: ['xs', 's', 'm', 'l'],
    fabrics: ['cotton', 'wool'],
    dateUpdated: new Date().toISOString(),
  },
  { 
    _id: '507f1f77bcf86cd799439015', 
    title: 'Kurtka dziecięca', 
    name: 'Kurtka dziecięca',
    price: '55zł', 
    url: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?w=300&h=200&fit=crop', 
    photos: [
      { url: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?w=600&h=400&fit=crop' },
    ],
    designer: 'Zosia W.', 
    description: 'Ciepła kurtka dla dzieci.',
    descriptionLong: 'Praktyczna kurtka dla dzieci na chłodniejsze dni. Wykrój zawiera rozmiary dla dziewczynek i chłopców.',
    categories: ['jackets'], 
    clients: ['girl', 'boy'],
    sizes: ['xs', 's', 'm'],
    fabrics: ['fleece', 'canvas'],
    dateUpdated: new Date().toISOString(),
  },
  { 
    _id: '507f1f77bcf86cd799439016', 
    title: 'Płaszcz zimowy', 
    name: 'Płaszcz zimowy',
    price: '65zł', 
    url: 'https://images.unsplash.com/photo-1539533018447-63fcce2678e3?w=300&h=200&fit=crop', 
    photos: [
      { url: 'https://images.unsplash.com/photo-1539533018447-63fcce2678e3?w=600&h=400&fit=crop' },
    ],
    designer: 'Ewa B.', 
    description: 'Elegancki płaszcz na zimę.',
    descriptionLong: 'Ciepły i elegancki płaszcz zimowy. Idealny na mroźne dni.',
    categories: ['jackets'], 
    clients: ['female'],
    sizes: ['s', 'm', 'l', 'xl'],
    fabrics: ['wool', 'fleece'],
    dateUpdated: new Date().toISOString(),
  },
  { 
    _id: '507f1f77bcf86cd799439017', 
    title: 'Sukienka letnia', 
    name: 'Sukienka letnia',
    price: '40zł', 
    url: 'https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=300&h=200&fit=crop', 
    photos: [
      { url: 'https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=600&h=400&fit=crop' },
    ],
    designer: 'Iza T.', 
    description: 'Lekka sukienka na lato.',
    descriptionLong: 'Przewiewna sukienka letnia idealna na upalne dni. Prosty wykrój odpowiedni dla początkujących.',
    categories: ['dresses'], 
    clients: ['female'],
    sizes: ['xs', 's', 'm', 'l', 'xl'],
    fabrics: ['cotton', 'linen'],
    dateUpdated: new Date().toISOString(),
  },
  { 
    _id: '507f1f77bcf86cd799439018', 
    title: 'Spodnie damskie', 
    name: 'Spodnie damskie',
    price: '38zł', 
    url: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=300&h=200&fit=crop', 
    photos: [
      { url: 'https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=600&h=400&fit=crop' },
    ],
    designer: 'Magda L.', 
    description: 'Eleganckie spodnie damskie.',
    descriptionLong: 'Klasyczne spodnie damskie pasujące do wielu stylizacji. Wykrój dla średniozaawansowanych.',
    categories: ['trousers'], 
    clients: ['female'],
    sizes: ['s', 'm', 'l', 'xl', 'xxl'],
    fabrics: ['cotton', 'stretch'],
    dateUpdated: new Date().toISOString(),
  },
];

export const getSamplePatternById = (id: string) => {
  return samplePatterns.find(p => p._id === id) || null;
};
